import React, { createContext, useContext, useState } from "react";
import { COPY } from "@/data";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = COPY[lang];
  const toggle = () => setLang((l) => (l === "pt" ? "en" : "pt"));
  return (
    <LangCtx.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
